(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-grid/assets/javascripts/casino-grid.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-grid/assets/javascripts/casino-grid.js');

'use strict';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CasinoGameCard = svs.components.casino_react.casinoGameCard.CasinoGameCard;
const CasinoProviderCard = svs.components.casino_react.casinoProviderCard.CasinoProviderCard;
const CasinoCategoryCard = svs.components.casino_react.casinoCategoryCard.CasinoCategoryCard;
const CasinoGridSkeleton = svs.components.casino_react.CasinoGridSkeleton;
const _svs$components$casin = svs.components.casino_react.common.constants,
  CardType = _svs$components$casin.CardType,
  GridDisplayModes = _svs$components$casin.GridDisplayModes,
  GridRulesets = _svs$components$casin.GridRulesets;
const useMaxGridItems = svs.components.casino_react.hooks.useMaxGridItems;
function getModelName(item) {
  return item.type === CardType.PROVIDER ? item.model.provider : item.model.name;
}
const CasinoGrid = _ref => {
  let displayMode = _ref.displayMode,
    isLoading = _ref.isLoading,
    items = _ref.items;
  const ruleset = GridRulesets[displayMode];
  const itemsToRender = useMaxGridItems(items, ruleset);
  if (isLoading) {
    return React.createElement(CasinoGridSkeleton, {
      displayMode: displayMode
    });
  }
  if (!(itemsToRender !== null && itemsToRender !== void 0 && itemsToRender.length)) {
    return React.createElement("ul", {
      className: "casino-grid"
    });
  }
  return React.createElement("ul", {
    className: "casino-grid ".concat(ruleset.classList.join(' '))
  }, itemsToRender.map((item, index) => React.createElement("li", {
    className: "casino-grid__item ".concat(ruleset.childClassList.join(' '))
    ,
    key: "item-".concat(getModelName(item), "-index-").concat(index)
  }, item.type === CardType.GAME && React.createElement(CasinoGameCard, _extends({
    gameName: getModelName(item)
  }, ruleset.cardComponentProps)), item.type === CardType.PROVIDER && React.createElement(CasinoProviderCard, {
    providerName: item.model.systemName
  }), item.type === CardType.CATEGORY && React.createElement(CasinoCategoryCard, {
    categoryName: item.model.systemName
  }))));
};
setGlobal('svs.components.casino_react.CasinoGrid', CasinoGrid);

 })(window);